import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, BrowserRouter as Router, Switch, Route, NavLink, useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Multiselect from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
// @mui  
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
import * as incidentReporteActions from "../../actions/incidentReporteActions";
import AccessDenied from '../common/AccessDenied';
import Loader from "../../components/Loader";

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const Enachrecon = (props) => {
  const { reportName } = useParams();
  const { actions, leadsData, usersData, sourceData, getUserModuleData, masterProfileData, leadStatusData } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  const [allLeads, setAllLeads] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [showLeadDetails, setShowLeadDetails] = useState(false);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [getSelectedLeadStatus, setSelectedLeadStatus] = useState([]);
  const [getSelectedLeadProfile, setSelectedLeadProfile] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allLeadSource, setAllLeadSource] = useState([]);

  const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [legalFormId, setLegalFormId] = useState('person');

  const [userRoleType, setUserRoleType] = useState('');
  const [loggeInUserID, setLoggeInUserID] = useState('');

  const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [selectedStatusIds, setSelectedStatusIds] = useState([]);

  useEffect(() => { 
    
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getUserModuleData(requestData);
    response.then((result) => {
      // console.log("Promise resolved -  lead list:", result);
      if (result.data.success === 1) {
        const permissionsData = result.data.data;
        const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'eNach Recon')?.view_permission;
        setPermissions(permissionsData);
        setViewModulePermissionStatus(hasViewPermissions);
        setUserHasPermission(hasViewPermissions);

        if(Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type')  && result.data.user_info[0].role_type !==''){
            setUserRoleType(result.data.user_info[0].role_type);
            // alert(result.data.user_info[0].role_type);
            setLoggeInUserID(result.data.user_info[0].user_id);
        }

        if(Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'is_external_user')  && result.data.user_info[0].is_external_user !== '' && result.data.user_info[0].is_external_user === "1"){
          setIsExternalUser(true);
        }
      }
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });
  }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID,setIsExternalUser]);

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    if (Array.isArray(usersData.data)) {
      const extractedData = usersData.data.map(item => {
        return { id: item.user_id, name: item.name };
      });
      const resultArr = Object.values(extractedData);
      setAllUsers(resultArr);
    }

    const objSource = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestSourceData = encryptData(objSource);
    const responseSource = actions.sourceData(requestSourceData,false);
    responseSource.then((result) => {
        // console.log("Promise resolved -  source data:", result); 
        if (result.data.success === 1) {
            const results = result.data.data.data
            const filteredResultArr = results.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.source_of_lead.localeCompare(b.source_of_lead)
            );
            const extractedData = sortedResultArr.map(item => {
              return { id: item.id, name: item.source_of_lead };
            });
            const resultArr = Object.values(extractedData);
            setAllLeadSource(resultArr);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
    });

    const objMasterProfile = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestDataMasterProfile = encryptData(objMasterProfile);
    const responseMasterProfile = actions.masterProfileData(requestDataMasterProfile, false);
    responseMasterProfile.then((result) => {
        // console.log("Promise resolved -  master profile data:", result); 
        if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.lead_profile_name.localeCompare(b.lead_profile_name)
            );

            const extractedData = sortedResultArr.map(item => {
              return { id: item.id, name: item.lead_profile_name };
            });
            const extractedObject = Object.values(extractedData);
            setAllMasterProfiles(extractedObject);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
    });

    const objLeadStatus = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestLeadStatusData = encryptData(objLeadStatus); 
    const leadStatusResponse = actions.leadStatusData(requestLeadStatusData);
    leadStatusResponse.then((result) => {
        // console.log("Promise resolved -  lead status data :", result); 
        if (result.data.success === 1) {
            setAllLeadStatusData(true);
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.lead_status.localeCompare(b.lead_status)
            );

            const extractedData = sortedResultArr.map(item => {
              return { id: item.id, name: item.lead_status };
            });
            const extractedObject = Object.values(extractedData);
            setAllLeadStatusData(extractedObject);

            const selectedIds = extractedObject
                .filter(item => item.name === "Ok to Proceed")
                .map(item => item.id);

            setSelectedStatusIds(selectedIds);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  lead status data :", error); 
    });

  }, [setAllUsers, setAllLeadSource, setAllMasterProfiles, setAllLeadStatusData, setSelectedStatusIds]);

  useEffect(() => {
    // setAllLeadStatusData(false);
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getLoggedinUserChild(requestData, false);

    response.then((result) => {
        // console.log("Promise resolved -  lead Status data:", result); 
        if (result.data.success === 1) {
            const results = result.data.data.data;
            
            const extractedData = results.map(item => {
              return { id: item.user_id, name: item.name };
            });
            const resultArr = Object.values(extractedData);
            setAllLoggedinUserChild(resultArr);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
    });
  }, [setAllLoggedinUserChild]);

  useEffect(() => {

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0]; 
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const formattedThreeMonthsAgo = threeMonthsAgo.toISOString().split('T')[0];  
  
    setValue('start_date', formattedThreeMonthsAgo);
    setValue('end_date', formattedToday);


    setShowLeadDetails(false);
    
    // console.log("Render Enachrecon component ", showLeadDetails);

    if (!selectedStatusIds || selectedStatusIds.length === 0) {
      return; // silently exit if no values are selected
    }

    if (!showLeadDetails) {
      setPreloaderStatus(true);

      const params = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType ,'start_date' : formattedThreeMonthsAgo, 'end_date': formattedToday};
      console.log("params = ", params);
      const requestData = encryptData(params);
      const response = actions.leadsData(requestData);
      response.then((result) => {
        // console.log("Promise resolved -  lead list:", result);
        if (result.data.success === 1) {
          setShowLeadDetails(true);
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllLeads(resultArr);
          setPreloaderStatus(false);
        }
      }).catch((error) => {
        console.error("Promise rejected -  lead list:", error);
        setPreloaderStatus(false);
      });
    }
  }, [setShowLeadDetails, leadsData, selectedStatusIds]);
  
  const onSubmit = (data) => {

    if(!selectedStatusIds || selectedStatusIds.length !== 0){
      setPreloaderStatus(true);
      const params = {
        'start': '0',
        'length': config.MAX_RECORDS,
        'assign_to': selectedUsers,
        'start_date': data.start_date,
        'end_date': data.end_date,
        'keyword': data.keyword,
        'lead_source': selectedLeadSource,
        'lead_profile': getSelectedLeadProfile,
        "user_role_type": userRoleType,
        "lead_status": selectedStatusIds,
      };
      console.log("params = ", params);
      const requestData = encryptData(params);
      const response = actions.leadsData(requestData, true, true);
      response.then((result) => {
        // console.log("Promise resolved -  lead list:", result);
        if (result.data.success === 1) {
          setShowLeadDetails(true);
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllLeads(resultArr);
          setPreloaderStatus(false);
        } else {
          setAllLeads([]);
          setPreloaderStatus(false);
        }
      }).catch((error) => {
        console.error("Promise rejected -  lead list:", error);
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onRowClickAction = (itemObj, btnAction) => {
    const encodedId = btoa(String(itemObj.id));
    if (btnAction === 'edit') {
      const url = `/dashboard/edit-lead/${encodedId}`;
    } else {
      setViewModalInfo(itemObj);
      setOpen(true);
    }
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  // Check if allLeads is an array and filter accordingly
  const filteredLeads = Array.isArray(allLeads)
  ? allLeads.filter(
      (lead) => lead.is_ok_to_proceed === "1" || lead.statusName === "Ok to Proceed"
    )
  : [];

  // Log the filtered leads to verify the output
  // console.log("Filtered Leads:", filteredLeads);

  const totalLeadsCount = Array.isArray(filteredLeads) ? filteredLeads.length : 0;
  // console.log("Total Filtered Leads Count:", totalLeadsCount);


  const [eNachAttemptedCount, setENachAttemptedCount] = useState(0);
  const [eNachSuccessCount, setENachSuccessCount] = useState(0);
  const [eNachFailureCount, setENachFailureCount] = useState(0);
  const [eNachPendingCount, setENachPendingCount] = useState(0);
  const [eNachNotAttemptedCount, setENachNotAttemptedCount] = useState(0);
  const [eNachFailed, setENachFailed] = useState([]);

  useEffect(() => {
    // Ensure allLeads is an array
    const leadsArray = Array.isArray(filteredLeads) ? filteredLeads : [];

    // Initialize counts
    let attemptedCount = 0;
    let successCount = 0;
    let failureCount = 0;
    const failedArray = [];

    // Proceed only if leadsArray is not empty
    if (leadsArray.length > 0) {
      leadsArray.forEach((item) => {
        // Check if EnachDetails exists and has an 'id' property
        if (item.EnachDetails && Object.prototype.hasOwnProperty.call(item.EnachDetails, 'id')) {
          // Increment the "E-Nach Attempted" count
          attemptedCount += 1;

          // Check for userEnachResponse and its response_status
          if (item.EnachDetails.userEnachResponse &&
            Object.prototype.hasOwnProperty.call(item.EnachDetails.userEnachResponse, 'response_status')) {
              
            const responseStatus = item.EnachDetails.userEnachResponse.response_status;

            // Increment success or failure counts based on responseStatus
            if (responseStatus === 'Success') {
              successCount += 1; // Increment success count
            } else {
              failureCount += 1; // Increment failure count
              failedArray.push(item);
            }
          }
        }
      });

      // After calculation, update the state with the final counts
      setENachAttemptedCount(attemptedCount);
      setENachSuccessCount(successCount);
      setENachFailureCount(failureCount);

      setENachFailed(failedArray);

      // Calculate and set pending count
      let pendingCount = attemptedCount - (successCount + failureCount);
      pendingCount = pendingCount < 0 ? 0 : pendingCount; // Ensure pendingCount is never negative
      setENachPendingCount(pendingCount);

      let notAttemptedCount =  totalLeadsCount - attemptedCount;
      notAttemptedCount = notAttemptedCount < 0 ? 0 : notAttemptedCount; // Ensure notAttemptedCount is never negative
      setENachNotAttemptedCount(notAttemptedCount);
    }
    // No else condition here to avoid logging errors
  }, [filteredLeads, totalLeadsCount, setENachAttemptedCount, setENachSuccessCount, setENachFailureCount, setENachPendingCount, setENachNotAttemptedCount, setENachFailed]); // Dependency array

  const filteredItems = filteredLeads.filter(item => {
    const name = item.name?.toLowerCase() || '';
    const formattedID = item.formatetdID?.toLowerCase() || '';
    const createdByName = item.createdByName?.toLowerCase() || '';
    const statusName = item.statusName?.toLowerCase() || '';
    const mobile = item.mobile?.toLowerCase() || '';
  
    return (
      name.includes(searchQuery.toLowerCase()) ||
      formattedID.includes(searchQuery.toLowerCase()) ||
      createdByName.includes(searchQuery.toLowerCase()) ||
      statusName.includes(searchQuery.toLowerCase()) ||
      mobile.includes(searchQuery.toLowerCase())
    );
  });

  const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
  const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);

  const handleHabileAddClient = (item) => {
     // alert(`In progress , need to implement ${leadId}`);
     const leadId = item.id;
     const pan = item.pancard_number;

     const prefillTemplateNameId = item.prefill_template_name;
     console.log("item ",item);
     if (Object.prototype.hasOwnProperty.call(item, 'pan_details_decrypt')) { 
        setLegalFormId('person');
        const isSoleProp = item.pan_details_decrypt.isSoleProp;
        const isSalaried = item.pan_details_decrypt.isSalaried;
        const isDirector = item.pan_details_decrypt.isDirector;

        if (isDirector === true) {
           setLegalFormId('business');
        } 
        
     }else{
        toast.error("Lead pan details are missing.", {
            position: "top-right",
        });
        return;
     }
     
     if(!pan || pan.trim() ==='' || pan === null){
        toast.error("Pan Number is required.", {
            position: "top-right",
        });
      } else if(!prefillTemplateNameId || prefillTemplateNameId.trim() ==='' || prefillTemplateNameId === null) { 
        toast.error("Prefill Template is required.", {
            position: "top-right",
        });
      } else {
        const params = { 'lead_id': leadId, 'legalFormId':legalFormId, "prefillTemplateNameId":prefillTemplateNameId};
        const requestData = encryptData(params);
        const response = actions.addClientHabileInfo(requestData);
        response.then((result) => {
          // console.log("Promise resolved - add/edit lead form:", result);
          console.log("habile message = ", result.data.message);
          if (result.data.success === 1) {
            console.log("habile response = ", result.data);

            if (Object.prototype.hasOwnProperty.call(result.data, 'habil_final_message') && result.data.habil_final_message !== '' && result.data.habil_final_message !== null) {
              toast.success(result.data.habil_final_message, {
                position: "top-right",
              });
            } else {
              toast.success(result.data.message, {
                position: "top-right",
              });
            }

          } else if (result.data.success === 0) {
            if (Object.prototype.hasOwnProperty.call(result.data, 'habil_final_message') && result.data.habil_final_message !== '' && result.data.habil_final_message !== null) {
              toast.error(result.data.habil_final_message, {
                position: "top-right",
              });
            } else {
              toast.error(result.data.message, {
                position: "top-right",
              });
            }
          } else {
            toast.error(result.data.habil_final_message, {
              position: "top-right",
            });
          }
        }).catch((error) => {
          // console.error("Promise rejected - add/edit lead form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
      }
      
      
  }

  const handleHabileAddIdentifier = (leadId,pan) => {
    // alert(`In progress , need to implement ${leadId}`);
    if(pan ===''){ 
     toast.error("Lead pan number is null.", {
         position: "top-right",
     });
     return;
   }
     const params = { 'lead_id': leadId};
      const requestData = encryptData(params);
      const response = actions.addIdentifierHabileInfo(requestData);
      response.then((result) => {
          // console.log("Promise resolved - add/edit lead form:", result);
           if (result.data.success === 1) { 
              console.log("habile response = ", result.data.data); 
                   toast.success(result.data.message, {
                       position: "top-right",
                   }); 
          } else {
              toast.error(result.data.message, {
                  position: "top-right",
              });
          }
      }).catch((error) => {
          // console.error("Promise rejected - add/edit lead form:", error);
          toast.error(error, {
              position: "top-right",
          });
      });
 }

  const checkLogout = () => {
    const authToken = localStorage.getItem('authToken');
    const logInTimestamp = localStorage.getItem('logInTimestamp');

    if (logInTimestamp !== null) {
      const loginTimestamp = parseInt(logInTimestamp, 10);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeElapsed = currentTime - loginTimestamp;
      const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

      if (timeElapsed >= autoLogoutTimeInSecod) {
        const params = { 'login_token': authToken };
        console.log("params : ", params);
        const requestData = encryptData(params);
        const response = actions.userLogout(requestData);
        response.then((result) => {
          if (result.data.success === 1) {
            const data = {};
            actions.loadUserAuth(false);
            actions.loginDataSuccess(data);
            localStorage.setItem("authToken", '');
            localStorage.setItem("logInTimestamp", '');
            navigate("/login");
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }
  }

  useEffect(() => {
    checkLogout();
  });

  const clearfix = {
    clear: 'both'
  };
  const textAlignRight = {
    textAlign: 'right'
  };

  const [enachItem, setEnachItem] = useState([]);
  const [proposedAmt, setProposedAmt] = useState('');
  const [proposedDebitDate, setProposedDebitDate] = useState('');
  const [openAmt, setOpenAmt] = useState(false);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const btnOpenUploadMissingData = (item) => {
     setOpenAmt(true);
    setEnachItem(item);
  }

  const handleCloseAmt = () => {
    setOpenAmt(false); 
    // setProposedAmt('');
   // setProposedDebitDate('');
    setEnachItem([]); 
  };


  const onSendEnachRegistrationAction = (item) => {  
    setPreloaderStatus(true); 
    
    // alert(item.emi_amount);
    const params = { 'lead_id': item.id, 'application_id': item.id,'brief' :'send_sms_to_user' ,'action' :'send_enach_link_to_user' ,'call_api_from' :'Lead','proposed_amount' : item.emi_amount,'proposed_debit_date' : item.debit_date};
    const requestData = encryptData(params);
    const response = actions.sendEnachRegistrationDetails(requestData);

    response.then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
         
        if (result.data.success === 1) { 
            console.log("response = ", result.data.data); 
            setPreloaderStatus(false);
                 toast.success(result.data.message, {
                     position: "top-right",
                 });

                // fetchHabileLoanApplicationsData(); 
                const obj = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType };
                const requestData = encryptData(obj);
                const response = actions.leadsData(requestData);
                response.then((result) => {
                  // console.log("Promise resolved -  lead list:", result);
                  if (result.data.success === 1) {
                    setShowLeadDetails(true);
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    setAllLeads(resultArr);
                  }
                }).catch((error) => {
                  console.error("Promise rejected -  lead list:", error);
                });   
            
        } else {
            setPreloaderStatus(false);
            toast.error(result.data.message, {
                position: "top-right",
            });
        }

        setOpenAmt(false); 
        setProposedAmt('');
        setProposedDebitDate('');
        setEnachItem([]); 
    }).catch((error) => {
        setPreloaderStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
            position: "top-right",
        });
    });

 };

 const handleFormSubmit = (data) => { 
    // console.log("data , ",data);

    if(data.emi_amount ===''){
      toast.error("Amount is required.", {
        position: "top-right",
      }); 
    }else if(data.emi_amount === '0'){
      toast.error("Amount is not valid.", {
        position: "top-right",
      }); 
   }else if(data.debit_date ===''){
      toast.error("Debit date is required.", {
        position: "top-right",
      });  
    }else{

      // setProposedAmt(data.emi_amount);
     // setProposedDebitDate(data.debit_date);
      enachItem.emi_amount =  data.emi_amount;
      enachItem.debit_date =  data.debit_date;
      onSendEnachRegistrationAction(enachItem);
    }
   
 }

 const handleAmtChange = (e) => {
  const amt = e.target.value;
   setProposedAmt(amt);
};

const handleDebitDateChange = (e) => {
  const date = e.target.value;
   setProposedDebitDate(date);
};

  const [showEnachFailed, setShowEnachFailed] = useState(false);
  const [currentPage2, setCurrentPage2] = useState(1);

  // Ensure eNachFailed is an array before applying .filter()
  const filteredItems2 = Array.isArray(eNachFailed) ? eNachFailed.filter(item => {
    const name = item.name?.toLowerCase() || '';
    const formattedID = item.formatetdID?.toLowerCase() || '';
    const createdByName = item.createdByName?.toLowerCase() || '';
    const statusName = item.statusName?.toLowerCase() || '';
    const mobile = item.mobile?.toLowerCase() || '';

    return (
      name.includes(searchQuery.toLowerCase()) ||
      formattedID.includes(searchQuery.toLowerCase()) ||
      createdByName.includes(searchQuery.toLowerCase()) ||
      statusName.includes(searchQuery.toLowerCase()) ||
      mobile.includes(searchQuery.toLowerCase())
    );
  }) : []; // If eNachFailed is not an array, return an empty array as fallback

  const startIndex2 = (currentPage2 - 1) * config.HUNDREAD_PER_PAGE;
  const endIndex2 = startIndex2 + config.HUNDREAD_PER_PAGE;
  const paginatedItems2 = filteredItems2.slice(startIndex2, endIndex2);
  const totalPages2 = Math.ceil(filteredItems2.length / config.HUNDREAD_PER_PAGE);

  const handlePageChange2 = (newPage) => {
    setCurrentPage2(newPage);
  };

  const [reasonCountArray, setReasonCountArray] = useState([]);

  useEffect(() => {

    const eNachFailedArray = Array.isArray(eNachFailed) ? eNachFailed : [];
    const reasonCount = {};

    if (eNachFailedArray.length > 0) {
      eNachFailedArray.forEach((item) => {

        if (item.EnachDetails && Object.prototype.hasOwnProperty.call(item.EnachDetails, 'id')) {

          // Check for userEnachResponse and its response_status
          if (item.EnachDetails.userEnachResponse &&
            Object.prototype.hasOwnProperty.call(item.EnachDetails.userEnachResponse, 'txn_err_msg')) {
              
            // const responseStatus = item.EnachDetails.userEnachResponse.response_status;
            const eNachFailedReason = item.EnachDetails.userEnachResponse.txn_err_msg;
            // console.log("eNachFailedReason : ", eNachFailedReason);

            reasonCount[eNachFailedReason] = (reasonCount[eNachFailedReason] || 0) + 1;
          }
        }
      });
    }

    // Convert reasonCount object to an array of [reason, count] pairs
    const reasonCountArray = Object.entries(reasonCount);
    setReasonCountArray(reasonCountArray);

  }, [eNachFailed, setReasonCountArray]);

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }
  return (
    <>
      <Helmet>
        <title> eNach Recon | Ckers </title>
      </Helmet>

      
      <Container>
      {!showEnachFailed && ( <>
        <div id='main-wrap' className='mb-3 mmt-7 filter'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='row mx-0'>
              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Start Date</span>
                    <input type='date' name='start_date' className='form-control'{...register('start_date')} />
                  </label>

                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="end-date">
                    <span>End Date</span>
                    <input type='date' name='end_date' className='form-control'{...register('end_date')} />
                  </label>

                </div>
              </div>
              <div className='col'>
                <div className='form-group mb-2'>
                  <span className='d-block'>&nbsp;</span>
                  <button className='btn btn-primary'>Search</button>
                </div>
              </div>

            </div>
          </form>
        </div>

        <div id='main-wrap' className='mb-4'>
          <div className='row justify-content-between'>
            <div className='col-md-6'> 
              <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
                eNach Recon
              </Typography>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Status, Name, Created by.. "
                    id="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                 
              </div>
            </div>
          </div>
          
          <div className='row justify-content-between'>
            <div className='col-md-6'>
              <span>Total Records : {totalLeadsCount}</span><br />
              <span>E-Nach Attempted : {eNachAttemptedCount}</span><br />
              <span>E-Nach Not Attempted : {eNachNotAttemptedCount}</span><br />
            </div>
            <div className='col-md-6'>
              <span>E-Nach Successful : {eNachSuccessCount}</span><br />
              <span>E-Nach Failure : {eNachFailureCount}</span><br />
              <span>E-Nach Pending : {eNachPendingCount}</span><br />
              <span>
                <button
                  type="button"
                  className="btn btn-danger text-white"
                  onClick={() => setShowEnachFailed(true)} // Show the component on button click
                >
                  E-NACH Failed
                </button>
              </span>
            </div>
          </div>
          <br/>
          <div className='table-wrap' style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th className='text-nowrap'>S. No.</th>
                  <th className='text-nowrap'>Name</th>
                  <th className='text-nowrap'>Mobile</th>
                  <th>Created by</th>
                  <th className='text-nowrap'>Created Date</th>
                  <th className='text-nowrap'>Status</th>
                  <th>Habile</th>
                  <th>E-Nach</th>
                  <th>E-Nach Status</th>
                  <th>Reason</th>
                  <th>Debit Date</th>
                  <th>AgreementNo</th>
                  <th className='text-nowrap'>Sent On Date</th>
                </tr>
              </thead>
              <tbody>
                {paginatedItems.map((item, index) => {

                let ENachSentStatus =  false;
                let ENachUserStatus =  false;
                let ENachUserHtml = '';
                let ENachFailedReason = '';  
                let ENachCreateDate = '';
                let ENachResponseStatus = '';

                let debitDate = '';
                let aggrementNo = '';

                if ( item.AllCloudDetails &&   Object.prototype.hasOwnProperty.call(item.AllCloudDetails, 'AgreementNo')
                ) {
                  aggrementNo = item.AllCloudDetails.AgreementNo;
                }

                if ( item.EnachDetails &&   Object.prototype.hasOwnProperty.call(item.EnachDetails, 'id')
                ) {
                    ENachSentStatus =  true;

                    ENachCreateDate = item.EnachDetails.enach_created_date;
                    debitDate = item.EnachDetails.proposed_debit_date;

                    if ( Object.prototype.hasOwnProperty.call(item.EnachDetails, 'userEnachResponse') && Object.prototype.hasOwnProperty.call(item.EnachDetails.userEnachResponse, 'response_status')
                    ) {
                        
                        ENachResponseStatus = item.EnachDetails.userEnachResponse.response_status;

                        if (item.EnachDetails.userEnachResponse.response_status === 'Success') {
                          ENachUserHtml = `<div>E-NACH process successfully done.</div>`;
                          ENachUserStatus = true;
                        }else{ 
                          ENachUserHtml = `<div>E-NACH process ${item.EnachDetails.userEnachResponse.response_status}.</div>`;
                          ENachFailedReason = item.EnachDetails.userEnachResponse.txn_err_msg;
                        }
                    }
                    
                }

                const safeCurrentPage2 = Number.isInteger(currentPage) ? currentPage : 1;
                const safeItemsPerPage = Number.isInteger(config.HUNDREAD_PER_PAGE) ? config.HUNDREAD_PER_PAGE : paginatedItems.length;
                const rowIndex2 = (safeCurrentPage2 - 1) * safeItemsPerPage + index + 1;
              return (   
                <> 
                  <tr key={index}>
                    <td>{rowIndex2}</td>
                    <td className='text-nowrap'>
                      <NavLink to={`/dashboard/edit-lead/${btoa(String(item.id))}`} style={{ color: "black"}}>
                        {item.name}
                      </NavLink>
                    </td>
                    <td>{item.mobile}</td>
                    <td>{item.createdByName}</td>
                    <td>{item.created_date}</td>
                    <td><span
                      className={(item.status === '1') ? "badge text-bg-success text-white" : (item.status === '2') ? "badge text-bg-warning text-white" : "badge text-bg-danger text-white"}
                    >{item.statusName === "CALL" ? 'No Interaction' : item.statusName}</span></td>
                    <td>
                      <button
                        type="button"
                        className={(item.habile_lms === 1) ? "d-none badge text-bg-success text-white float-right" : "badge text-bg-success text-white float-right"}
                        onClick={() => handleHabileAddClient(item)}
                      >
                        Habile - LMS
                      </button>

                      <div className={(item.habile_lms === 0) ? "d-none float-right" : "float-right"}>
                        Sent to Habile <span className={(item.sentToHabileLmsDate === '') ? "d-none" : ""}>on {item.sentToHabileLmsDate}</span>
                        <span className={(item.sentToHabileLmsByUser === '') ? "d-none" : ""}>&nbsp;By {item.sentToHabileLmsByUser}</span>
                      </div>
                    </td>

                    <td>
                      <button
                        type="button"
                        className={(ENachUserStatus) ? "d-none badge btn btn-primary text-white float-right" : "badge btn btn-primary text-white float-right"}
                        onClick={(e) => {
                          e.preventDefault();
                          /* onSendEnachRegistrationAction(item) */
                          btnOpenUploadMissingData(item)
                        }
                        }
                      >
                        {preloaderStatus && (<>
                          <div className="spinner-border small-preloader" role="status" >
                            <span className="visually-hidden">Loading...</span>
                          </div></>)}
                        E-NACH Registration
                      </button>

                      {(ENachSentStatus) && (
                        <>
                          <div style={clearfix} className="text-success align-right">E-NACH link sent to #{item.mobile}</div>
                          {/* <div style={clearfix} className={(ENachUserStatus) ? "text-success align-right" : "text-danger align-right"} dangerouslySetInnerHTML={{ __html: ENachUserHtml.replace(/\n/g, '<br />') }} /> */}
                        </>)}
                    </td>
                    <td>
                      <div 
                        style={{ 
                          color: ENachResponseStatus === "Success" ? "green" : 
                                ENachResponseStatus === "Aborted" ? "orange" : 
                                ENachResponseStatus === "Failed" ? "red" : 
                                "black" 
                        }}
                      >
                        {ENachResponseStatus}
                      </div>
                    </td>
                    <td>
                      <div 
                        style={{ 
                          color: ENachResponseStatus === "Success" ? "green" : 
                                ENachResponseStatus === "Aborted" ? "orange" : 
                                ENachResponseStatus === "Failed" ? "red" : 
                                "black" 
                        }}
                      >
                        {ENachFailedReason}
                      </div>
                    </td>
                    <td>{debitDate}</td>
                    <td>{aggrementNo}</td>
                    <td>{ENachCreateDate}</td>
                  </tr>
                  
                </>);
                
              })}

                { paginatedItems.length < 1 && (
                    <>
                      <tr>
                        <td colSpan={10} className='text-center py-3 fw-bold'>No record found</td>
                      </tr>
                    </>
                )}
              </tbody>
            </table>
          </div>
          <div>
            <nav className='mb-1'>
              <ul className="pagination pagination-md justify-content-end">
                {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                  <li className="page-item">
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      disabled={currentPage === page}
                      className="page-link"
                    >
                      {page}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </>)}

      {showEnachFailed && ( <>
        <div id='main-wrap' className='mb-4'>
          <div className='row justify-content-between'>
            <div className='col-md-10'>
              <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
                eNach Recon Failed
              </Typography>
            </div>

            <div className='col-md-2'>
              <button
                  type="button"
                  className="btn btn-info text-white"
                  onClick={() => setShowEnachFailed(false)} // Show the component on button click
                >
                  Back
                </button>
            </div>
          </div>

          <div className='row justify-content-between'>
            <div className='col-md-6'>
              <span>Total Records : {eNachFailureCount}</span><br />
              {reasonCountArray.length > 0 &&
                reasonCountArray.map(([reason, count], index) => (
                  <>
                    <span key={index}>{reason}: {count}</span>
                    <br />
                  </>
                ))
              }
            </div>
          </div>
          <br/>
          <div className='table-wrap' style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th className='text-nowrap'>S. No.</th>
                  <th className='text-nowrap'>Lead Name</th>
                  <th className='text-nowrap'>Mobile</th>
                  {!isExternalUser && (<> <th>Created by</th> </>)}
                  <th className='text-nowrap'>Created Date</th>
                  <th className='text-nowrap'>Status</th>
                  <th>E-Nach Status</th>
                  <th>Reason</th>
                  <th className='text-nowrap'>Sent On Date</th>
                </tr>
              </thead>
              <tbody>
                {paginatedItems2.map((item, index) => {

                  let ENachSentStatus = false;
                  let ENachUserStatus = false;
                  let ENachUserHtml = '';
                  let ENachFailedReason = '';
                  let ENachCreateDate = '';
                  let ENachResponseStatus = '';

                  if (item.EnachDetails && Object.prototype.hasOwnProperty.call(item.EnachDetails, 'id')
                  ) {
                    ENachSentStatus = true;

                    ENachCreateDate = item.EnachDetails.enach_created_date;

                    if (Object.prototype.hasOwnProperty.call(item.EnachDetails, 'userEnachResponse') && Object.prototype.hasOwnProperty.call(item.EnachDetails.userEnachResponse, 'response_status')
                    ) {

                      ENachResponseStatus = item.EnachDetails.userEnachResponse.response_status;

                      if (item.EnachDetails.userEnachResponse.response_status === 'Success') {
                        ENachUserHtml = `<div>E-NACH process successfully done.</div>`;
                        ENachUserStatus = true;
                      } else {
                        ENachUserHtml = `<div>E-NACH process ${item.EnachDetails.userEnachResponse.response_status}.</div>`;
                        ENachFailedReason = item.EnachDetails.userEnachResponse.txn_err_msg;
                      }
                    }

                  }

                  const safeCurrentPage2 = Number.isInteger(currentPage2) ? currentPage2 : 1;
                  const safeItemsPerPage = Number.isInteger(config.HUNDREAD_PER_PAGE) ? config.HUNDREAD_PER_PAGE : paginatedItems2.length;
                  const rowIndex = (safeCurrentPage2 - 1) * safeItemsPerPage + index + 1;
                  return (
                    <>
                      <tr key={index}>
                        <td>{rowIndex}</td>
                        <td className='text-nowrap'>
                          <NavLink to={`/dashboard/edit-lead/${btoa(String(item.id))}`} style={{ color: "black" }}>
                            {item.name}
                          </NavLink>
                        </td>
                        <td>{item.mobile}</td>
                        {!isExternalUser && (<> <td>{item.createdByName}</td> </>)}
                        <td>{item.created_date}</td>
                        <td><span
                          className={(item.status === '1') ? "badge text-bg-success text-white" : (item.status === '2') ? "badge text-bg-warning text-white" : "badge text-bg-danger text-white"}
                        >{item.statusName === "CALL" ? 'No Interaction' : item.statusName}</span></td>
                        <td>
                          <div
                            style={{
                              color: ENachResponseStatus === "Success" ? "green" :
                                ENachResponseStatus === "Aborted" ? "orange" :
                                  ENachResponseStatus === "Failed" ? "red" :
                                    "black"
                            }}
                          >
                            {ENachResponseStatus}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              color: ENachResponseStatus === "Success" ? "green" :
                                ENachResponseStatus === "Aborted" ? "orange" :
                                  ENachResponseStatus === "Failed" ? "red" :
                                    "black"
                            }}
                          >
                            {ENachFailedReason}
                          </div>
                        </td>
                        <td>{ENachCreateDate}</td>
                      </tr>
                    </>);

                })}

                {paginatedItems2.length < 1 && (
                  <>
                    <tr>
                      <td colSpan={10} className='text-center py-3 fw-bold'>No record found</td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div>
            <nav className='mb-1'>
              <ul className="pagination pagination-md justify-content-end">
                {Array.from({ length: totalPages2 }, (_, index) => index + 1).map(page => (
                  <li className="page-item">
                    <button
                      key={page}
                      onClick={() => handlePageChange2(page)}
                      disabled={currentPage2 === page}
                      className="page-link"
                    >
                      {page}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </>)}

        {preloaderStatus && <Loader />}
      </Container>
      

      

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div className='modal-custom rounded'>
          <div className='modal-head'>
            <h4 id="modal-title">Lead  : {viewModalInfo.name}</h4>
            <Button onClick={handleClose} color="primary" className=' btn'>
              <i className="bi bi-x">&nbsp;</i>
            </Button>
          </div>
          <div className='modal-body'>
            <div className='row mb-2 pb-1'>
              <div className='col-4'><b>Lead ID :</b></div>
              <div className='col-7 ps-0'>{viewModalInfo.id}</div>
            </div>

            <div className='row mb-2 pb-1'>
              <div className='col-4'><b>Created By :</b></div>
              <div className='col-7 ps-0'>{viewModalInfo.lead_created_by}</div>
            </div>

            <div className='row mb-2 pb-1'>
              <div className='col-4'><b>Lead Status :</b></div>
              <div className='col-7 ps-0'><span className={(viewModalInfo.status === '1') ? "badge text-bg-success text-white" : (viewModalInfo.status === '2') ? "badge text-bg-warning text-white" : "badge text-bg-danger text-white"}>{viewModalInfo.statusName}</span></div>
            </div>
          </div>
        </div>
      </Modal>


      <Modal
                open={openAmt}
                onClose={handleCloseAmt}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">What is the proposed EMI amount?</h4>
                        <Button onClick={handleCloseAmt} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>EMI Amount <a style={{ color: "red" }}>*</a></span>
                                                <input
                                                    type='number'
                                                    id='emi_amount'
                                                    name='emi_amount'
                                                    className='form-control'
                                                    {...register('emi_amount')}
                                                    onChange={handleAmtChange}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                                                <input
                                                    type='date'
                                                    id='debit_date'
                                                    name='debit_date'
                                                    className='form-control'
                                                    {...register('debit_date')}
                                                    onChange={handleDebitDateChange}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

    </>
  );
}

function mapStateToProps(state) {
  return {
    leadsData: state.leadsData,
    usersData: state.usersData,
    sourceData: state.sourceData,
    getUserModuleData: state.getUserModuleData,
    masterProfileData: state.masterProfileData,
    leadStatusData: state.leadStatusData,
    getLoggedinUserChild: state.getLoggedinUserChild,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default), dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Enachrecon);